// Libs
import classNames from 'classnames/bind';
import { Stack, Typography } from '@mui/material';
import { useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { useAppDispatch } from '~/utils/redux/hooks';
import { useEffect, useState } from 'react';
// Components, Layouts, Pages
import { Loading } from '~/components/common';
import { InformationOrderComponent, TableOverbookingOrderDetail } from '~/components/module/order';
// Others
import { EMPTY_STRING } from '~/utils/constants/common';
import { getOrderDetail } from '~/thunks/order/orderThunk';
import { IOrderDetail, IOrderDetailOverbooked, IParamQueryOrderDetail } from '~/utils/interface/order';
import { orderActions, selectIsRefreshOrderDetail } from '~/thunks/order/orderSlice';
// Styles, images, icons
import styles from './OverbookingOrderTab.module.scss';

type Props = {};

const cx = classNames.bind(styles);

const OverbookingOrderTab = (props: Props) => {
  //#region Destructuring Props
  const {} = props;
  //#endregion Destructuring Props

  //#region Declare Hook
  const dispatch = useAppDispatch();
  const { id: orderId } = useParams();
  const { t } = useTranslation(['admin/order', 'common/base']);
  //#endregion Declare Hook

  //#region Selector
  const isRefreshOrderDetail = useSelector(selectIsRefreshOrderDetail);
  //#endregion Selector

  //#region Declare State
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [detailOrder, setDetailOrder] = useState<IOrderDetail>();

  const [paramObject] = useState<IParamQueryOrderDetail>({
    orderId: orderId || EMPTY_STRING,
    type: 'overbooked items',
  });

  const [overbookedItemsDetail, setOverbookedItemsDetail] = useState<IOrderDetailOverbooked>();
  //#endregion Declare State

  //#region Declare Memo
  //#endregion Declare Memo

  //#region Implement Hook
  useEffect(() => {
    const params = {
      orderId: orderId || EMPTY_STRING,
      type: 'overview',
    };

    handleGetOrderDetailInfo(params);
  }, []);

  useEffect(() => {
    handleGetDetailOrderOverbooking(paramObject);
  }, [paramObject]);

  useEffect(() => {
    if (!isRefreshOrderDetail) return;

    handleGetDetailOrderOverbooking(paramObject);

    dispatch(orderActions.setRefreshOrderDetail(false));

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isRefreshOrderDetail]);
  //#endregion Implement Hook

  //#region Handle Function
  const handleGetOrderDetailInfo = (params: IParamQueryOrderDetail) => {
    setIsLoading(true);

    dispatch(getOrderDetail(params))
      .unwrap()
      .then((res) => {
        const { data } = res;

        setDetailOrder(data as IOrderDetail);
      })
      .catch((_error) => {})
      .finally(() => {
        setIsLoading(false);
      });
  };

  const handleGetDetailOrderOverbooking = (params: IParamQueryOrderDetail) => {
    setIsLoading(true);

    dispatch(getOrderDetail(params))
      .unwrap()
      .then((res) => {
        const { data } = res;

        setOverbookedItemsDetail(data as IOrderDetailOverbooked);
      })
      .catch((_error) => {})
      .finally(() => {
        setIsLoading(false);
      });
  };
  //#endregion Handle Function

  return (
    <Stack id='overbookingOrderTabComponent' className={cx('container')} gap={8}>
      <InformationOrderComponent detailOrder={detailOrder} />

      <Stack>
        <Typography className={cx('title')}>{t('order_detail_title_overbooked_items')}</Typography>

        <TableOverbookingOrderDetail overbookedItems={overbookedItemsDetail} />
      </Stack>

      {isLoading && <Loading />}
    </Stack>
  );
};

export default OverbookingOrderTab;
